<template>
  <Head :title="vipCategory.meta_title ?? vipCategory.name">
    <meta
      name="description"
      :content="vipCategory.meta_description ?? vipCategory.name"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.categories.slug', [vipCategory.slug])"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section
    class="blog-single-hero"
    :class="vipCategory.coverImage? 'pb-20 md:pb-40 lg:pb-48' : ''"
  >
    <div class="container relative">
      <div class="text-center my-6">
        <span class="text-4xl font-bold mt-1 lg:text-7xl text-center">
          {{ vipCategory.name }}
        </span>
      </div>
      <img
        v-if="vipCategory.coverImage"
        :src="vipCategory.coverImage.url"
        class="absolute left-0 right-0 max-h-96 mx-auto px-[15px]"
      >
    </div>
  </section>

  <section class="sticky z-30 top-0 pt-[5.5rem] md:pt-20 pb-3 bg-red-100 border-b border-gray-200">
    <VipsFilter
      ref="vipsFilter"
      v-model:search="search"
      :total-vips="filteredVipsCount"
      :highest-vip-price="highestVipPrice"
      :occasions="occasions"
      :popular-categories="popularCategories"
      :categories="categories"
      :initial-search="initialSearch"
      :initial-filter="initialFilter"
      @filter:reset="resetFilter"
      @filter:recalculate="recalculateFilter"
      @filter:submit="submitFilter"
    />
  </section>

  <section
    class="all-vips bg-white pb-12"
    :class="{
      'pt-72 lg:pt-60 md:pt-60 xl:pt-60' : vipCategory.coverImage,
    }"
  >
    <div v-show="filteredVips.length > 0">
      <div
        v-for="(vipsGroup, i) in groupedVips"
        :key="`vip-group-${i}`"
      >
        <div class="container">
          <div class="w-full md:order-3">
            <div class="w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-8 my-4">
              <Vip
                v-for="vip in vipsGroup"
                :key="`vip-${vip.username}-${vip.id}`"
                :vip="vip"
                :always-mobile="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="filteredVips.length === 0">
      <section class="all-vips-no-results bg-white pb-20 overflow-hidden">
        <div class="container">
          <div class="mt-4 text-center">
            <span class="block text-center text-2xl lg:text-5xl">
              <i18n-t
                keypath="vips.nothing-found"
                scope="global"
              >
                <template #count>
                  <strong>0</strong>
                </template>
              </i18n-t>
            </span>
          </div>
        </div>
      </section>
    </div>
  </section>

  <section class="blog-single-content bg-white text-lg pb-4 pt-20">
    <div class="container">
      <div class="lg:w-4/5 lg:mx-auto">
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="vipCategory.content" />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
  </section>
</template>

<script>
import VipsFilterMixin from '../../Mixins/VipsFilter';
import VipsFilter from '../../Components/VipsFilter.vue';
import Vip from '../../Components/Vip.vue';

export default {
  components: {
    VipsFilter,
    Vip,
  },

  mixins: [VipsFilterMixin],

  props: {
    vipCategory: {
      type: Object,
      required: true,
    },
  },

  methods: {
    filterRoute() {
      return this.localeRoute('frontend.categories.slug', [this.vipCategory.slug]);
    },
  },
};
</script>
